import React from 'react'

const SvgIcSuccess = props => (
  <svg viewBox="0 0 18 14" fill="none" {...props}>
    <path d="M6 11.2L1.8 7 .4 8.4 6 14 18 2 16.6.6 6 11.2z" fill="#00D455" />
  </svg>
)

export default SvgIcSuccess
